export default {
    newsSixTitle: "2020年全球金融App下载量同比增长15%",
    newsTime: "发布时间",
    newsRead: "阅读量",
    newsSixSource:"文章来源：",
    newsSixDetail: [
        {
            p:"移动应用营销公司 Liftoff 的最新研究结果表明，全球市场中金融类应用在 2020 年表现出色，该类应用的下载总量达到了 46 亿次，同比增长 15%。"
        },
        {
            p:"Liftoff 与 App Annie 共同发布的最新版《移动金融应用程序报告》（Mobile Finance Apps Report）发现，尽管受到 COVID-19 疫情所带来的影响，但金融类应用的下载增幅依然比所有应用类别的平均值多出 2 倍。"
        },
        {
            p:"报告显示，2020 年全球用户花费在金融应用上的总时间增加至 163 亿小时，同比增长 45%。"
        },
        {
            p:"Liftoff 首席执行官兼联合创始人 Mark Ellis 解释道：“COVID-19 和随之而来的市场不确定性促使用户将更多时间放在了金融应用上。随着许多人在探索新的理财功能，营销人员也会考虑一些新策略，为新生用户提供资源，在增加留存率的同时增强用户对应用程序内理财功能的信心。”"
        },
        {
            p:"调查还显示，全球用户对金融科技类应用的接纳速度更快，这类应用的采用率比大型银行应用多出 10.8 倍。"
        },
        {
            p:"投资和交易应用（例如「Robinhood」）是 2020 年全球下载量最高的应用之一。这一趋势在美国尤为明显。在该市场中，移动用户花费在前五大投资应用上的时间同比增加了 135%。紧随其后的是加拿大和墨西哥，增幅达到 115%；亚太地区中韩国的增幅最大，达 120%。"
        },
        {
            p:"App Annie 市场洞察主管 Lexi Sydow 预计，全球市场内金融应用的增长趋势将持续到 2021 年。她表示：“在 COVID-19 带来的金融不利因素和市场担忧的影响下，全球股市参与率在 2020 年迅速飙升，大批消费者转向应用程序。全球用户在头部投资应用上花费的时间增长了 55%，美国市场则增长了 135%。”"
        },
        {
            p:"有趣的是，Android 系统在金融应用领域的表现超过了 iOS，其单次安装成本（CPI）比 iOS 低 4.5 到 7 倍。此外 Android 系统用户的转化率也比 iOS 用户多出两倍。"
        }
    ]
}